export const DATA_RANGE_DAYS = 30;

export const SECONDS_PER_DAY = 86400;
